<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
    OrderExtraField: () => lazyLoadComponent(import('@components/OrderExtraField')),
  },
  props: {
    currentOrder: {
      type: Object,
      default: () => {},
      required: true,
    },
    memberInfo: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userSameAsMember: true,
      submitData: {},
    }
  },
  computed: {
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      return {
        fullName: [{
          required: true,
          message: '請輸入使用人姓名'
        }],
        gender:[{
          required:true,
          message:'請選擇性別'
        }],
        phoneNumber: [{
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  watch: {
    userSameAsMember: 'updateUserByMember',
    currentOrder: {
      handler(val) {
        this.submitData = cloneDeep(val)
      },
      immediate: true,
    },
  },
  methods: {
    updateUserByMember() {
      const fields = ['memberId', 'fullName', 'gender', 'phoneCode', 'phoneNumber', 'email']
      fields.forEach((field) => {
        this.submitData[field] = field === 'memberId' ? this.memberInfo.id : this.memberInfo[field]
      })
    },
    async onClickStore() {
      await this.$refs.form.validate()
      this.$emit('update', this.submitData)
    },
    onClickClose() {
      this.$emit('close')
    },
  },
}
</script>
<template>
  <div :class="$style.orderformSection">
    <div class="orderformSection__right__header">
      <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i class="el-dialog__close el-icon el-icon-close"></i></button>
      <h4 class="orderformSection__right__title">編輯備註</h4>
    </div>
    <div class="orderformSection__right__content">
      <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form-item--normal-margin el-form-item--white-bg">
        <div style="display: flex; margin-bottom: 10px"> <h6 style="margin-top: 0">使用人</h6> <el-checkbox v-model="userSameAsMember" class="check-by-head">使用人同客戶</el-checkbox> </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="fullName" class="el-form-item--white-bg-border" label="姓名">
              <el-input v-model="submitData.fullName" :disabled="userSameAsMember" placeholder="姓名"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="gender-box" prop="gender">
              <el-radio-group v-model="submitData.gender" class="no-bg-radio-group" :disabled="userSameAsMember">
                <el-radio label="male">先生</el-radio>
                <el-radio label="female">小姐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="phoneNumber" class="el-form-item--white-bg-border" label="電話">
              <el-input v-model="submitData.phoneNumber" :disabled="userSameAsMember" placeholder="手機號碼" autocomplete="tel">
                <CountryCodePicker slot="prepend" v-model="submitData.phoneCode" :disabled="userSameAsMember" />
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form class="el-form-item--normal-margin el-form-item--white-bg el-form--label-top">
        <OrderExtraField :default-value="submitData" />
        <el-form-item label="使用人備註">
          <small style="display: block; opacity: 0.5; line-height: 1.3; margin-bottom: 10px">客戶可瀏覽此備註。若是不需要提供客戶瀏覽的資訊，請使用「內部備註」功能</small>
          <el-input v-model="submitData.note" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="is-round is-fullwidth" type="primary" :loading="loading" @click="onClickStore"> 儲存 </el-button>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {
  :global {
    .orderformSection {
      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }
        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;
          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }
          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }
          .el-tabs__nav-wrap::after {
            display: none;
          }
          .el-tabs__header {
            margin-bottom: 0;
          }
          .el-tabs--top {
            margin-left: 60px;
            @include max-lg {
              margin-left: 30px;
            }
          }
        }
        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;
          @include max-lg {
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>